import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class ProgressionsService {
    constructor(private api: ApiService) { }

    getProgressionOrderFormats() { 
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.progressions + '/getProgressionOrderFormats')
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/progressions.service.ts